import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const PlanName = ({ plan, planType }) => {
  const resultPlanType =
    planType || plan?.planType || plan?.metadata?.cms_type || plan?.metadata?.class;

  if (!resultPlanType) {
    return <span />;
  }

  switch (resultPlanType) {
    case 'influencer':
      return <FormattedMessage defaultMessage="Influencer" />;
    case 'ace':
      return <FormattedMessage defaultMessage="Ace" />;
    case 'starter':
      return <FormattedMessage defaultMessage="Starter" />;
    case 'free-forever':
      return <FormattedMessage defaultMessage="Free Forever" />;
    case 'acast-creator-network':
      return <FormattedMessage defaultMessage="Creator Network" />;
    default:
      return <span>{resultPlanType}</span>;
  }
};

PlanName.propTypes = {
  plan: PropTypes.object,
  planType: PropTypes.string,
};

export default PlanName;
